import React, { useMemo } from "react";
import {
  Abilities,
  Player,
  RoundState,
  VoteState,
} from "context/interfaces/GameContextInterface";
import RubberBand from "react-reveal/RubberBand";
import Swing from "react-reveal/Swing";
// Css
import classes from "./Player.module.scss";
import {
  useGameState,
  pickChancellor,
  handleSearchAbilityChoose,
  handleNextPresidentChoose,
  killPlayer,
} from "context/GameContext";

interface Props {
  player: Player;
  index: number;
}

const PlayerComponent: React.FC<Props> = ({ player, index }) => {
  const {
    code,
    isChancellorIndex,
    isPresidentIndex,
    wasChancellorIndex,
    wasPresidentIndex,
    roundState,
    playersNumber,
    remainingPlayersNumber,
    activeAbility,
    player: playerOfGame,
    gameRules,
  } = useGameState();

  const isChancellorCandidate = useMemo(
    () =>
      RoundState.PickingChancellor === roundState &&
      player.id !== isPresidentIndex &&
      !player.isDead &&
      ((player.id !== wasChancellorIndex && player.id !== wasPresidentIndex) ||
        (player.id !== wasChancellorIndex &&
          (playersNumber === 5 || remainingPlayersNumber <= 5))),
    [
      isPresidentIndex,
      player.id,
      player.isDead,
      playersNumber,
      remainingPlayersNumber,
      roundState,
      wasChancellorIndex,
      wasPresidentIndex,
    ]
  );

  const isChosenCandidate = useMemo(
    () =>
      roundState === RoundState.AbilityActive &&
      (activeAbility === Abilities.Kill ||
        activeAbility === Abilities.Search ||
        activeAbility === Abilities.NextPresident) &&
      player.id !== isPresidentIndex &&
      !player.isDead,
    [activeAbility, isPresidentIndex, player.id, player.isDead, roundState]
  );

  const roleImageSrc = useMemo(() => {
    if (roundState === RoundState.GameFinished) {
      if (player.isLiberal) return "assets/img/common/role-liberal.svg";
      else if (!player.isLiberal && player.isHitler)
        return "assets/img/common/role-hitler.svg";
      else return "assets/img/common/role-fascist.svg";
    } else if (player.isDead) return "assets/img/board/back-role-dead.svg";
    else if (
      (playerOfGame.isHitler && gameRules.hitlerKnowsFascists) ||
      (!playerOfGame.isLiberal && !playerOfGame.isHitler) ||
      (playerOfGame.id === player.id && playerOfGame.isLiberal) ||
      (playerOfGame.id === player.id &&
        playerOfGame.isHitler &&
        !gameRules.hitlerKnowsFascists)
    ) {
      if (player.isLiberal) return "assets/img/common/role-liberal.svg";
      else if (!player.isLiberal && player.isHitler)
        return "assets/img/common/role-hitler.svg";
      else return "assets/img/common/role-fascist.svg";
    } else return "assets/img/board/secret-role.svg";
  }, [
    gameRules.hitlerKnowsFascists,
    player,
    playerOfGame.id,
    playerOfGame.isHitler,
    playerOfGame.isLiberal,
    roundState,
  ]);

  const handlePlayerClick = () => {
    if (playerOfGame.id === isPresidentIndex)
      switch (roundState) {
        case RoundState.PickingChancellor:
          if (isChancellorCandidate && playerOfGame.id === isPresidentIndex)
            pickChancellor(code, player.id);
          break;
        case RoundState.AbilityActive:
          if (isChosenCandidate) {
            if (activeAbility === Abilities.Search)
              handleSearchAbilityChoose(code, player.id);
            else if (activeAbility === Abilities.NextPresident)
              handleNextPresidentChoose(code, player.id);
            else if (activeAbility === Abilities.Kill)
              killPlayer(code, player.id);
          }
          break;
        default:
          break;
      }
  };

  return (
    <div className={classes.container} onClick={handlePlayerClick}>
      <span
        className={`${classes.player_name} 
        ${playerOfGame.id === player.id && classes.highlight_me}`}
      >
        {index + 1 + "." + player.name}
      </span>
      <div
        className={`${classes.secret_role_container} 
        ${
          isChancellorCandidate &&
          classes.secret_role_container_isChancellorCandidate
        }
        ${isChosenCandidate && classes.secret_role_container_isChosenCandidate}
        ${
          (isChancellorCandidate || isChosenCandidate) &&
          playerOfGame.id === isPresidentIndex &&
          classes.cursor_pointer
        }
        `}
      >
        <img className={classes.secret_role} src={roleImageSrc} alt="" />
        <RubberBand>
          {isPresidentIndex === player.id && (
            <img
              className={classes.current_position}
              src="assets/img/board/president.svg"
              alt=""
            />
          )}
        </RubberBand>
        <RubberBand>
          {isChancellorIndex === player.id && (
            <img
              className={classes.current_position}
              src="assets/img/board/chancellor.svg"
              alt=""
            />
          )}
        </RubberBand>
        <Swing>
          {wasPresidentIndex === player.id && (
            <img
              className={classes.previous_position}
              src="assets/img/board/president.svg"
              alt=""
            />
          )}
        </Swing>
        <Swing>
          {wasChancellorIndex === player.id && (
            <img
              className={classes.previous_position}
              src="assets/img/board/chancellor.svg"
              alt=""
            />
          )}
        </Swing>
        <Swing>
          {player.voteState !== VoteState.None && (
            <div
              className={`${classes.vote_state} ${
                player.voteState === VoteState.Agree
                  ? classes.agree
                  : classes.decline
              }`}
            />
          )}
        </Swing>
      </div>
    </div>
  );
};

export default PlayerComponent;
